// extracted by mini-css-extract-plugin
export default {"cls1":"z1dfX7gVXTmIET2g_6Ew","cls2":"_grJZ19nIOmYrqJsuP3o z1dfX7gVXTmIET2g_6Ew","isTabletDown":"DxaTaCRBrCl6_AXnsQD2","isPhone":"erRfFKPdV84XGdu_Qtam"};